module.exports = __webpack_public_path__ + "static/media/floating.b8c6e806.png";